import { o as browserPonyfill, H as HistoryService, S as StringService } from './index2.js';
import { T as TrackingService } from './index3.js';

const getFileName = (url) => url.substring(url.lastIndexOf('/') + 1);
const downloadFile = async (url, myHeaders) => fetch(`${url}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    headers: myHeaders,
});
const DownloadService = {
    // eslint-disable-next-line class-methods-use-this
    get defaultTracking() {
        return {
            event: 'download',
            component_name: 'roche-download-teaser',
        };
    },
    async handleDownload(url) {
        var _a;
        const myHeaders = new browserPonyfill.exports.Headers({ Origin: (_a = HistoryService === null || HistoryService === void 0 ? void 0 : HistoryService.getActiveUrl()) === null || _a === void 0 ? void 0 : _a.origin });
        const fileName = getFileName(url);
        const response = await downloadFile(url, myHeaders);
        if (response.status !== 200) {
            return;
        }
        const blob = await response.blob();
        const contentType = response.headers.get('content-type');
        let fileUrl = url;
        if (contentType !== 'application/pdf') {
            fileUrl = URL.createObjectURL(blob);
        }
        const fileLink = this.addLinkElement(fileUrl, fileName, contentType);
        this.trackDownloadLinkClick(fileName);
        fileLink.click();
        fileLink.remove();
    },
    addLinkElement(url, filename, contentType) {
        const fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.download = filename;
        fileLink.setAttribute('skipOnClickNotice', '');
        if (contentType === 'application/pdf') {
            fileLink.setAttribute('target', '_blank');
        }
        document.body.appendChild(fileLink);
        return fileLink;
    },
    trackDownloadLinkClick(fileName) {
        TrackingService.push(Object.assign(Object.assign({}, this.defaultTracking), { additionalParameters: {
                file_type: StringService.getExtension(fileName),
            }, value: fileName }));
    },
};

export { DownloadService as D };

//# sourceMappingURL=index12.js.map